import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import SeoHeaders from "../components/seoheaders";
import Select from "react-select"
import * as wActs from "../actions/website-actions";
import * as adActs from "../actions/advertise-actions";
import * as bActs from "../actions/billing-actions";
import {FormattedMessage} from "react-intl";
import * as wConst from '../consts/website-consts';
import { Link } from 'react-router-dom';
import DropZone from 'react-dropzone';
//import ProfileSelectBox from '../components/profileselectbox';
import {culturePath} from "../actions/website-actions";
import SwBanner from '../components/swbanner'
import BuyAdBanner from "../components/buyadbanner";

//Using This So I Can Build Buy Page Without Repeating 20 Steps
const testState = {
  country: "US",
  homecc: "BR",
  imgHeight: 100,
  imgName: "200x100.gif",
  imgWidth: 200,
  packageId: 2024,
  payby: "TOK",
  showingImg: true,
  size: "200x100",
  startDate: "2019-06-01",
  step: "3",
  title: "Fetish Sandy, 25, priveontvangst escort in Belo Horizonte",
  upDisabled: false,
  url: "https://www.topescort.nl/sandy-2944",
  usertype: 1,
  packData: {
    Amount: 50,
    CurrencyCode: "EUR",
    Description: "7 dagen 200x100 formaat",
    IsCountryPackage: true,
    MaxAds: 3,
    Name: "7 dagen 200x100 formaat",
    PackageId: 2024,
    Period: 7,
    Size: "200x100",
    SizeType: "Fixed",
    SoldAds: 0,
    Tokens: 500,
    Type: "Banner",
  }
};
const testUpload = {
  Code: 200,
  Message: "Success",
  Result: {
    Guid: "828c1e15-a346-46e5-abb9-6ef8bbe3c4eb",
    Url: "https://cdn.topescort.nl/uploads/828c1e15-a346-46e5-abb9-6ef8bbe3c4eb.gif",
    FileName: "828c1e15-a346-46e5-abb9-6ef8bbe3c4eb.gif",
    FileHash: "263e54454ab907cbfb1032b32c500bee",
    Length: 11833,
    Width: 200,
    Height: 100,
    OriginalFileName: "200x100.gif",
    OriginalLength: 11833
  }
};

class Advertise extends Component {

  //Comp Events
  constructor(props) {
    super(props);
    let dte = new Date();
    this.state = {
      step: "1",
      size: "",
      usertype: "",
      homecc: "",
      country: "",
      packageId: 0,
      packData: {},
      startDate: `${dte.getFullYear()}-${this.zeroPad(dte.getMonth()+1)}-${this.zeroPad(dte.getDate())}`,
      payby: "EUR",
      url: "",
      title: "",
      showingImg: false,
      img: null,
      imgName: "",
      imgWidth: "0px",
      imgHeight: "0px",
      upDisabled: true,
      loadBiller: "PAY"
    };
    this.file = null;
  }
  componentDidMount() {


    this.props.dispatch({ type: wConst.ACTION_SET_PAGETYPE, payload: "advertise" });

    //if(!wActs.isLoggedIn(this.props.WebPage)) {
    //  this.props.history.push(wActs.getCultPath(this.props.WebPage,"/login"));
    //}

   //************TEST CODE***************
   //this.setState(testState);
   //this.props.dispatch(bActs.GetBillingData());
   //this.props.dispatch({type: wConst.FETCH_ADUPLOAD_FULLFILLED,payload: testUpload});
   //return;
   //************************************


    let data = localStorage.getItem("ad-data");
    if(!wActs.isNullOrUndefined(data)) {
      localStorage.removeItem("ad-data");
      let tObj = JSON.parse(data);
      this.setState({
        country: tObj.country,
        packageId: tObj.packageId,
        packData: tObj.packData,
        payby: tObj.payby,
        size: tObj.size,
        url: tObj.url,
        usertype: tObj.usertype,
        homecc: tObj.homecc,
        step: "1"
      });
      return;
    }
    if(!wActs.isLoggedIn(this.props.WebPage)) {
      this.setState({payby: "EUR"});
    }

    if(typeof window !== "undefined") {
      let tUrl = document.location.href;
      let qDta = {};
      let biller = wActs.getParameterByName("biller",tUrl,"");
      if(biller !== "") {
        switch(biller.toUpperCase()) {
          case "VXS" : {
            let user1 = wActs.getParameterByName("user_1",tUrl,"");
            let user2 = wActs.getParameterByName("user_2",tUrl,"");
            qDta.OrderId = wActs.getParameterByName("order_id",tUrl,"");
            let params = user1.split(":");
            qDta.PackId = params[0];
            qDta.Country = params[1];
            qDta.HomeCountry = params[2];
            qDta.UserId = params[3];
            params = user2.split(":");
            qDta.StartDate = params[1];
            qDta.Guid = params[2];
            qDta.RecordId = 0;
            if(wActs.isLoggedIn(this.props.WebPage)) {
              qDta.RecordId = this.props.WebPage.User.RecordId;
            }
            if(wActs.isNullOrEmpty(qDta.Guid.trim()))  { qDta.TargetUrl = localStorage.getItem("ad-target-url"); }
            let cPath = this.props.WebPage.Settings.SelectedLocal;
            if(!cPath.startsWith("/")) { cPath = `/${cPath}/`; }
            this.setState({ step: "5", loadBiller: "VXS", bQuery: qDta });
            this.props.dispatch(bActs.VXSCheckOrder(qDta.OrderId, qDta.PackId, qDta.Country, qDta.HomeCountry, qDta.UserId, qDta.RecordId, qDta.StartDate, qDta.Guid, cPath,"EUR"));
          }
        }
      }
    }



  }
  componentDidUpdate() {
    //console.log("Here Dude...");
    let adUrl = this.props.Ads.AdUrl;
    if (this.iFramely && !this.iFramely.hasChildNodes() && this.state.step == "2") {
      if (adUrl.Loaded && adUrl.Result.Code == 200 && adUrl.Result.Result.Html) {
        const range = document.createRange();
        this.iFramely.appendChild(range.createContextualFragment(adUrl.Result.Result.Html));
      }
    }
    try {window.Siteways.Banners.PlaceBanners();} catch(ex) {}
  }

  //Event handlers
  handleSubmit(evt) {
    evt.preventDefault();

    let cc = "";
    let homeCC = "";
    let userType = "";
    let size = "";
    let payby = "";
    try {
      cc = this.Country.state.value.value;
    } catch(ex){}
    try {
      homeCC = this.HomeCountry.state.value.value;
    } catch(ex){}
    try {
      userType = this.UserType.state.value.value;
    } catch(ex){}
    try {
      size = this.Size.state.value.value;
    } catch(ex){}
    try {
      payby = this.PayBy.state.value.value;
    } catch(ex){}


    if(isNaN(this.state.packageId) || this.state.packageId <= 0) {
      this.props.dispatch(wActs.showWarning("WARN","Please select a package for your banner placement"));
      return;
    }

    window.ScrollTopAlways();
    if(!wActs.isLoggedIn(this.props.WebPage)) {
      localStorage.setItem("ad-data",JSON.stringify({
        size: size,
        country: cc,
        packageId: this.state.packageId,
        payby: this.state.payby,
        homecc: homeCC,
        usertype: userType
      }));

      window.ScrollTopAlways();
      this.props.dispatch({type: wConst.LOGIN_SET_URL,payload: document.location.href});
      this.props.history.push(wActs.getCultPath(this.props.WebPage,"/login"));
      return;
    } else {
      if((size !== "Profile" && !this.isAgent()) || this.isModel()) {
        this.fillUrlInfo();
      }
    }
    this.setState({step: "2",homecc: homeCC, usertype: userType, size: size, country: cc, payby: payby});
  }
  handleProfileChange(sel) {
    this.setState({url: sel.url});
    this.props.dispatch(adActs.GetAdUrlInfo(sel.url));
  }
  handlePackageClick(packId) {
    let pData = this.props.Ads.AdPackages.Result.filter((t)=>{return t.PackageId == packId})[0];
    this.setState({packageId: packId, packData: pData});
  }
  handleSizeChange(sel) {
    let homecc = wActs.isNullOrEmpty(this.HomeCountry.state.value) ? "" : this.HomeCountry.state.value.value;
    let cc = wActs.isNullOrEmpty(this.Country.state.value) ? "" : this.Country.state.value.value;
    let type = wActs.isNullOrEmpty(this.UserType.state.value) ? "" : this.UserType.state.value.value;
    this.props.dispatch(adActs.GetAdPackages(cc,sel.value,type,homecc));
    this.setState({packageId: 0, size: sel.value, homecc: homecc, country: cc, usertype: type});
  }
  handleTypeChange(sel) {
    let homecc = wActs.isNullOrEmpty(this.HomeCountry.state.value) ? "" : this.HomeCountry.state.value.value;
    let cc = wActs.isNullOrEmpty(this.Country.state.value) ? "" : this.Country.state.value.value;
    this.props.dispatch(adActs.GetAdSizes(sel.value,cc,homecc));
    this.setState({packageId: 0, size: "", usertype: sel.value, homecc: homecc, country: cc});
  }
  handleCountryChange(sel) {
    let homecc = wActs.isNullOrEmpty(this.HomeCountry.state.value) ? "" : this.HomeCountry.state.value.value;
    let utype = wActs.isNullOrEmpty(this.UserType.state.value) ? "2" : this.UserType.state.value.value;
    this.props.dispatch(adActs.GetAdSizes(utype,sel.value,homecc));
    this.setState({packageId: 0, size: "", country: sel.value, usertype: utype, homecc: homecc});
  }
  handleHomeCountryChange(sel) {
    let cc = wActs.isNullOrEmpty(this.Country.state.value) ? "" : this.Country.state.value.value;
    let utype = wActs.isNullOrEmpty(this.UserType.state.value) ? "2" : this.UserType.state.value.value;
    this.props.dispatch(adActs.GetAdSizes(utype,cc,sel.value));
    this.setState({packageId: 0, size: "", homecc: sel.value, usertype: utype, country: cc});

  }
  handlePayChange(sel) {
    this.setState({payby: sel.value});
  }
  handleDateChange(e) {
    this.setState({startDate: e.target.value});
  }
  handleUrlChange(e) {
    let val = e.target.value;
    this.setState({url: val});
    if(this.iFramely) {this.iFramely.innerHTML = "";}
    if(val.startsWith("http://") || val.startsWith("https://")) {
      this.props.dispatch(adActs.GetAdUrlInfo(val));
    }
  }
  handleTitleChange(e) {
    let val = e.target.value;
    this.setState({title: val});
  }
  handleFile(files) {
    if(!files[0]) {
      return;
    }
    this.setState({showingImg: true, imgName: files[0].name});
    this.file = files[0];
    let fR = new FileReader();
    fR.onload = (res) => {
      let img = new Image();
      let w=0; let h=0;
      let self = this;
      img.onload = function () {
        debugger;
        w = this.width; h = this.height;
        let s = self.state.size;
        let aWidth = s == "Profile" ? 200 : s.split("x")[0];
        let aHeight = s == "Profile" ? 200 : s.split("x")[1];
        let upDis = true;
        if ((aWidth == w && aHeight == h) || s === "Profile") { upDis = false; }
        self.setState({ img: res.target.result, imgWidth: this.width, imgHeight: this.height, upDisabled: upDis });
      };
      img.src = res.target.result;
    };
    fR.readAsDataURL(files[0]);
  }
  handleUpload(evt) {
    evt.preventDefault();
    let title = this.Title.value;
    let dta = {
      packid: this.state.packageId,
      url: this.state.url,
      title: title,
      file: this.file, filename: this.file.name
    };

    localStorage.setItem("ad-target-url",this.state.url);

    window.ScrollTopAlways();
    this.props.dispatch(adActs.UploadAd(dta));
    this.props.dispatch(bActs.GetBillingData());
    this.setState({ step: "3", title: title });
  }
  handleBackToBilling(e) {
    e.preventDefault();
    this.setState({ step: "3"});
  }
  handleGoBack(e) {
    e.preventDefault();
    this.setState({
      packageId: 0,
      step: "1",
    });
  }
  handlePayByCredits(e,cur) {
    e.preventDefault();
    let dta = {
      PackageId: this.state.packageId,
      Guid: this.props.Ads.AdUpload.Result.Guid,
      CurrencyCode: cur,
      CountryCode: this.state.country,
      StartDate: this.state.startDate,
      UserId: this.props.WebPage.User.UserId,
      TargetUrl: localStorage.getItem("ad-target-url")
    };
    window.ScrollTopAlways();
    this.setState({step: "4"});
    this.props.dispatch(adActs.PayByCredits(dta));
  }
  handleContinueToBilling(e) {
    e.preventDefault();
    if(wActs.isNullOrEmpty(this.state.url)) {
      this.props.dispatch(wActs.showWarning("WARN","Please select a profile to fill in the url info"));
      return;
    }
    window.ScrollTopAlways();
    let title = this.Title.value;
    localStorage.setItem("ad-target-url",this.state.url);
    this.props.dispatch(bActs.GetBillingData());
    this.setState({ step: "3", title: title });
  }
  handleBillerBuy(e,bType) {
    e.preventDefault();
    window.ScrollTopAlways();
    let cPath = this.props.WebPage.Settings.SelectedLocal;
    if(!cPath.startsWith("/")) { cPath = `/${cPath}/`; }
    this.props.dispatch(bActs.VXSCreateOrder(this.state.packageId, this.state.country, this.state.homecc,
    this.props.WebPage.User.UserId, this.state.startDate, this.props.Ads.AdUpload.Result.Guid, cPath, this.state.packData.CurrencyCode))
    this.setState({loadBiller: bType, step: "4"});
  }



  //Utility functions
  fillUrlInfo() {
    if(wActs.isLoggedIn(this.props.WebPage)) {
      try {
        let url = this.props.Ads.AdUserInfo.Result.Url;
        this.setState({url: url});
        this.props.dispatch(adActs.GetAdUrlInfo(url));
      } catch(ex) {}
    }
  }
  normalizeDisplayName(str) {
    return str.trim().replace(" ","-").toLowerCase();
  }
  zeroPad(num) {
    if(num<10) {
      return "0" + num;
    } else {
      return "" + num;
    }
  }
  isAgent() {
    try {
      if(wActs.isLoggedIn(this.props.WebPage)) {
        let type = this.props.WebPage.User.Type;
        if(type.toLowerCase().indexOf("agent")>-1) {
          return true;
        }
      }
    }catch(ex) {}
    return false;
  }
  isModel() {
    try {
      if(wActs.isLoggedIn(this.props.WebPage)) {
        let type = this.props.WebPage.User.Type;
        if(type.toLowerCase().indexOf("model")>-1) {
          return true;
        }
      }
    }catch(ex) {}
    return false;
  }
  isUser() {
    try {
      if(wActs.isLoggedIn(this.props.WebPage)) {
        let type = this.props.WebPage.User.Type;
        if(type.toLowerCase().indexOf("member")>-1) {
          return true;
        }
      }
    }catch(ex) {}
    return false;
  }
  getTranslation(key) {
    return this.props.WebPage.Translations[key];
  }
  getTranslationReplace(key,reps) {
    let resp = "";
    try {
      resp = this.props.WebPage.Translations[key];
      reps.map((v) => {
        resp = resp.replace(v.Key, v.Value);
      });
    } catch(ex) {}
    return resp;
  }

  //Render the page
  render() {
    let ccDef = null;
    let ccNme = "";
    let sizeDef = null;
    let sizeNme = "";
    let aWidth = this.state.size.split("x")[0];
    let aHeight = this.state.size.split("x")[1];
    let isValid = false;
    let tokens = 0; let euros = 0;
    let packs = null;
    let sizes = [];
    let loggedIn = wActs.isLoggedIn(this.props.WebPage);
    let billers = [];
    let Homedisabled = this.isModel() || this.isAgent();
    let Typedisabled = this.isAgent() || this.isModel();
    let showUpload = true;
    let fdta = {};
    let utypes = [];

    let pays = [];
    let defPay = {};

    if(wActs.isLoggedIn(this.props.WebPage)) {
      pays = [
        {label: `€ Euros`, value: "EUR"},
        {label: `${this.getTranslation("dash.tokens")}`, value: "TOK"},
      ];
    } else {
      pays = [
        {label: "Euros", value: "EUR"},
      ];
    }
    defPay = pays[0];
    let url = typeof window === "undefined" ? this.props.WebPage.ServerParams.Referer + this.props.WebPage.ServerParams.Query : document.location.href;
    let defTitle = "";
    let defhcc = null;
    let defType = null;
    let qCC = this.state.country;
    let qType = this.state.usertype;
    let qHCC = this.state.homecc;

    if(this.props.Ads.Loaded) {
      utypes = this.props.Ads.AdUserTypes.Result.map((v) => {
        return {label: v.DisplayValue, value: v.Id};
      });
      if(wActs.isNullOrEmpty(qCC)) { qCC = wActs.getParameterByName("country",url,""); }
      if(wActs.isNullOrEmpty(qCC)) { qCC = this.props.Ads.AdUserInfo.Result.Current.Country.Code; }

      if(this.state.country !== null) {
        this.props.Ads.AdCountries.Result.map((v) => {
          if(v.Code === qCC) {
            ccDef = {label: v.Name, value: v.Code};
            ccNme = v.Name;
          }
        });
      }
      if(loggedIn) {
        if(this.state.step === "2") {
          if(this.state.size === "Profile") {
            showUpload = false;
          }
        }

        if(!wActs.isNullOrEmpty(this.props.Ads.AdUserInfo.Result)) {
          this.props.Ads.AllCountries.Result.map((v) => {
            if(v.Value === this.props.Ads.AdUserInfo.Result.Home.Country.Code) {
              defhcc = {label: v.DisplayValue, value: v.Value};
            }
          });
          utypes.map((v) => {
            if(v.value == this.props.Ads.AdUserInfo.Result.Type.Id) {
              defType = v;
            }
          });
        }
      } else {
        if(wActs.isNullOrEmpty(this.state.usertype)) { defType = wActs.getParameterByName("type",url,""); }
        if(wActs.isNullOrEmpty(defType) && !wActs.isNullOrEmpty(this.state.usertype)) { defType = this.state.usertype }
        utypes.map((v) => {
          if(v.value == defType) {
            defType = v;
          }
        });
        if(wActs.isNullOrEmpty(this.state.homecc)) { defhcc = wActs.getParameterByName("homecountry",url,""); }
        if(wActs.isNullOrEmpty(defhcc) && !wActs.isNullOrEmpty(this.state.homecc)) { defhcc = this.state.homecc; }
        if(wActs.isNullOrEmpty(defhcc)) {defhcc = this.props.Ads.AdUserInfo.Result.Home.Country.Code;}
        this.props.Ads.AllCountries.Result.map((v) => {
          if(v.Value === defhcc) {
            defhcc = {label: v.DisplayValue, value: v.Value};
          }
        });
      }


      if(this.props.Ads.AdPackages.Loaded) {
        packs = this.props.Ads.AdPackages.Result;
        if(wActs.isNullOrUndefined(packs)) { packs = []; }
      }
      if(this.props.Ads.AdSizes.Loaded) {
        sizes = this.props.Ads.AdSizes.Result.map((v) => {return {value: v.Name, label: v.Name}});
        sizeNme = wActs.isNullOrEmpty(this.state.size) ? sizes[0].value : this.state.size;
        sizes.map((v) => {
          if(v.value == sizeNme) {sizeDef = v}
        });
      }
      if(this.state.showingImg) {
        if((aWidth == this.state.imgWidth && aHeight == this.state.imgHeight) || this.state.size == "Profile") {
          isValid = true;
        }
      }
      let adUrl = this.props.Ads.AdUrl;
      if(adUrl.Loaded && adUrl.Result.Code == 200) {
        defTitle = adUrl.Result.Result.Title.trim();
      }

      //Setup For Step 3 Here
      if(this.state.step == "3") {
        if(loggedIn) {
          tokens = this.props.WebPage.Wallet.Tokens;
          euros = this.props.WebPage.Wallet.Amount;
        }
        if(this.props.Billing.Loaded) {
          let sBillers = this.props.Billing.BillingData.SiteBillers.filter((t) => {return t.Domain === wActs.getSubdomain(document.location.hostname)});
          sBillers.map((v) => {
            let tBill = this.props.Billing.BillingData.Billers.filter((t) => {return t.Id === v.BillerId})[0];
            if(!wActs.isNullOrUndefined(tBill)) {
              billers.push(tBill);
            }
          });
        }
      }
      if(this.state.step === "4" && this.props.CreateOrder.Loaded && this.props.CreateOrder.Result.Code === 200) {
        fdta = this.props.CreateOrder.Result.Result;
        setTimeout(() => {
          this.billingForm.submit();
        },1000);
      }
    }


    let centerBan = "four-center-banner" + wActs.MainLeftStyle(this.props.WebPage);

    return (
      <div className={`main-content${wActs.MainLeftStyle(this.props.WebPage)} left`}>
        <SeoHeaders Position={"Top"}/>
        <div className="white-box advertise-content">
          {!this.props.Ads.Loaded &&
            <p style={{width: "100%", display: "flex", alignContent: "center", justifyContent: "center"}}>
              <img src="/imgs/loader.gif" width={"100px"} height={"100px"} alt={"Loading"}/>
            </p>
          }
          {(this.props.Ads.Loaded && this.state.step<4) &&
            <React.Fragment>
              <div className="footer-ad-text"><pre dangerouslySetInnerHTML={{__html: this.getTranslation("page.footer.thebiggestnetworkintheworld")}}></pre></div>
              <div style={{width: "100%", background: "white", height: "20px"}}></div>
              <div className="ad-greybox">
                <div className="stepnumber"><span>{this.state.step}</span></div>
                <div className="steptext">
                  <span>{this.getTranslationReplace("page.advertise.stepx",[{Key: "{{step}}",Value:this.state.step}])}</span>
                  {this.state.step === "1" &&
                    <p>{this.getTranslation("page.advertise.step1.text")}</p>
                  }
                  {this.state.step === "2" &&
                    <p>Now please select an image, url and title for your banner.</p>
                  }
                  {this.state.step === "3" &&
                    <p>Now you can select a billing method or confirm you order paying with credit.</p>
                  }
                  {this.state.step === "4" &&
                    <p>Please wait while we process your order.</p>
                  }
                  {this.state.step === "5" &&
                    <p>Please wait while we check your order approval.</p>
                  }
                </div>
                <div className="steptext">
                  <span>{this.getTranslation("page.advertise.promo1")}</span>
                  <p>{this.getTranslationReplace("page.advertise.promo1.text",[{Key: "{{SiteName}}",Value: this.props.WebPage.Settings.SiteName}])}</p>
                </div>
              </div>
            </React.Fragment>
          }
          {this.props.Ads.Loaded && this.state.step === "1" &&
            <React.Fragment>
              <div className="ad-greybox">
                <div className="form-label" style={{verticalAlign: "top", paddingTop: "9px"}}>{this.getTranslation("page.advertise.advertisementcountry")}:</div>
                <div className="form-select">
                  <Select ref={(ref) => {this.Country=ref}} onChange={(sel) => {this.handleCountryChange(sel)}} style={wActs.customStyles} options={this.props.Ads.AdCountries.Result.map((v) => {return {label: v.Name, value: v.Code}})} placeholder="Select country..." defaultValue={ccDef}/>
                  <div className="note-text">{this.getTranslation("page.advertise.advertisementcountry.note")}</div>
                </div>
              </div>
              <div className="ad-greybox">
                <div className="form-label" style={{verticalAlign: "top", paddingTop: "9px"}}>{this.getTranslation("page.advertise.homecountry")}:</div>
                <div className="form-select">
                  <Select isDisabled={Homedisabled} ref={(ref) => {this.HomeCountry=ref}} onChange={(sel) => {this.handleHomeCountryChange(sel)}} style={wActs.customStyles} options={this.props.Ads.AllCountries.Result.map((v) => {return {label: v.DisplayValue, value: v.Value}})} defaultValue={defhcc} placeholder="Select country..."/>
                  <div className="note-text">{this.getTranslation("page.advertise.homecountry.note")}</div>
                </div>
              </div>
              <div className="ad-greybox">
                <div className="form-label">{this.getTranslation("page.advertise.iama")}:</div>
                <div className="form-select"><Select ref={(ref) => {this.UserType = ref}} isDisabled={Typedisabled} onChange={(sel) => {this.handleTypeChange(sel)}} ref={(ref) => {this.UserType=ref}} style={wActs.customStyles} options={utypes} defaultValue={defType} placeholder="Select..."/></div>
              </div>
              {this.props.Ads.AdSizes.Loaded &&
                <div className="ad-greybox">
                  <div className="form-label">{this.getTranslation("page.advertise.advertisementsize")}:</div>
                  <div className="form-select"><Select ref={(ref) => {this.Size = ref}} onChange={(sel) => {this.handleSizeChange(sel)}} style={wActs.customStyles} options={sizes} defaultValue={sizeDef}/></div>
                </div>
              }
              <div className="ad-greybox">
                <div className="form-label">{this.getTranslation("page.advertise.startdate")}:</div>
                <div className="form-date-input">
                  <input type="date" defaultValue={this.state.startDate} onChange={(e) => {this.handleDateChange(e)}}/>
                </div>
              </div>
              <div className="ad-greybox">
                <div className="form-label">{this.getTranslation("page.advertise.payby")}:</div>
                <div className="form-select"><Select ref={(ref) => {this.PayBy = ref}} style={wActs.customStyles} options={pays} defaultValue={defPay} onChange={(sel) => {this.handlePayChange(sel)}}/></div>
              </div>

              {this.props.Ads.AdPackages.Loaded &&
                <div className="ad-packages">
                  {packs.length == 0 &&
                  <div className="ad-greybox">
                    There are no packages for this setup, please change your size or country.
                  </div>
                  }
                  {packs.map((p,i)=>{
                    let soldOut = false;
                    if(p.MaxAds>0 && p.SoldAds >= p.MaxAds) {
                      soldOut = true;
                    }
                    return(
                      <div key={"packoption-" + i} className="package-option" onClick={soldOut ? null : (e) => {this.handlePackageClick(p.PackageId)}}>
                        <div className="package-check">
                          {this.state.packageId === p.PackageId &&
                            <i className="fas fa-check"></i>
                          }
                        </div>
                        <div className="package-name">{p.Name.replace("X","x")}</div>
                        <div className="package-desc">{p.Description}</div>
                        <div className="package-price">
                          {(this.state.payby === "TOK" && !soldOut) && <a title="Tokens"><i className="fas fa-coins"></i>&nbsp;{p.Tokens}</a>}
                          {(this.state.payby === "EUR" && !soldOut) && <a title="Euros">{p.Amount}&nbsp;<i className="fa fa-euro-sign"></i></a>}
                          {soldOut && <a title="Soldout">Soldout</a>}
                        </div>
                      </div>
                    )
                  })}
                </div>
              }
              {!this.props.Ads.AdPackages.Loaded &&
                <p style={{width: "100%", display: "flex", alignContent: "center", justifyContent: "center"}}>
                  <img src="/imgs/loader.gif" width={"100px"} height={"100px"} alt={"Loading"}/>
                </p>
              }

              <div className="ad-sample">
                {sizeNme !== "Profile" &&
                  <div>
                    <div className="sample">Sample</div>
                    <div className={"banner-" + sizeNme}>
                      <div className="sample-text">Escort Ad Here<br/>({sizeNme})</div>
                    </div>
                  </div>
                }
              </div>
              <button type="button" className="ad-greenbutton" name="" onClick={(evt) => {this.handleSubmit(evt)}}>{this.getTranslation("page.advertise.createad")}</button>

            </React.Fragment>
          }
          {this.props.Ads.Loaded && this.state.step === "2" &&
            <React.Fragment>
              <div className="ad-greybox">
                <div className="form-label">Change Options:</div>
                <div className="form-select"><a href="#none" onClick={(e)=>{this.handleGoBack(e)}}>Click here to go back and update your options.</a></div>
              </div>
              <div className="ad-greybox">
                <div className="form-label">Country:</div>
                <div className="form-select">{ccNme}</div>
              </div>
              <div className="ad-greybox">
                <div className="form-label">Size:</div>
                <div className="form-select">{this.state.size}</div>
              </div>
              <div className="ad-greybox">
                <div className="form-label">Start Date:</div>
                <div className="form-select">{this.state.startDate}</div>
              </div>
              {this.isAgent() && this.state.size == "Profile" &&
                <div className="ad-greybox">
                  <div className="form-label" style={{verticalAlign: "top", paddingTop: "9px"}}>Select Profile:</div>
                  <div className="form-select">
                    <ProfileSelectBox style={wActs.customStyles} placeholder="Start typing to select a profile..." onChange={(sel) => {this.handleProfileChange(sel)}}/>
                    <div className="note-text">Choose 1 of your models to promote. You can type their name in to search your list of profiles</div>
                  </div>
                </div>
              }
              <div className="ad-greybox">
                <div className="form-label" style={{verticalAlign: "top", paddingTop: "9px"}}>Target Url:</div>
                <div className="form-input">
                  <input ref={(ref)=>{this.Url=ref}} type="text" onBlur={(e) => {this.handleUrlChange(e)}} defaultValue={this.state.url} placeholder="https://www.yourdomain.com"/>
                  {this.state.size === "Profile" &&
                    <div className="note-text">The url will auto fill when you select one of your profiles.</div>
                  }
                </div>
              </div>
              {this.props.Ads.AdUrl.Loaded &&
                <React.Fragment>
                  <div className="ad-greybox">
                    <div className="form-label">Banner Title:</div>
                    <div className="form-input"><input ref={(ref)=>{this.Title=ref}} type="text" onBlur={(e) => {this.handleTitleChange(e)}} defaultValue={this.state.title == "" ? defTitle : this.state.title}/></div>
                  </div>
                  {!wActs.isNullOrEmpty(this.props.Ads.AdUrl.Result) && !wActs.isNullOrEmpty(this.props.Ads.AdUrl.Result.Result) && !wActs.isNullOrEmpty(this.props.Ads.AdUrl.Result.Result.Html) &&
                    <div className="ad-greybox" ref={(ref) => {this.iFramely = ref}}>

                    </div>
                  }
                </React.Fragment>
              }
              {this.props.Ads.AdUrl.Loading &&
                <p style={{width: "100%", display: "flex", alignContent: "center", justifyContent: "center"}}>
                  <img src="/imgs/loader.gif" width={"100px"} height={"100px"} alt={"Loading"}/>
                </p>
              }
              {showUpload &&
                <React.Fragment>
                  <div className="ad-greybox" style={{lineHeight: "15px", fontSize: "1.3rem"}}>
                    Click the upload icon or drag a file into the box below to upload your banner. The image must be of
                    type <span style={{color: "Red"}}>JPG</span>,<span style={{color: "Red"}}>GIF</span> or <span
                    style={{color: "Red"}}>PNG</span> only. And the image must be the exact size of <span
                    style={{color: "Red"}}>{this.state.size}</span>.
                  </div>
                  <div className="ad-uploadarea">
                    <DropZone onDrop={(files) => {
                      this.handleFile(files)
                    }}>
                      {({getRootProps, getInputProps}) => (
                        <div className="ad-upload" {...getRootProps()}>
                          <input type="file" style={{display: "none"}} {...getInputProps()}
                                 accept=".gif,.jpg,.png,.jpeg"/>
                          <div className="ad-upload-text">
                            <i className="fa fa-upload"></i><br/><span>Drag file or click here to upload.</span>
                          </div>
                        </div>
                      )}
                    </DropZone>
                  </div>
                  <div className="ad-preview">
                    {!this.state.showingImg &&
                    <div className={"banner-200x200"}>
                      <div className="sample-text">Upload Image<br/>to preview it</div>
                    </div>
                    }
                    {this.state.showingImg &&
                    <div className={"banner-200x200"}>
                      <img src={this.state.img} ref={(ref) => {
                        this.Img = ref
                      }} alt={"Uploaded image"} style={{maxWidth: "200px", maxHeight: "200px"}}/>
                    </div>
                    }
                  </div>
                  {this.state.showingImg &&
                  <React.Fragment>
                    <div className={"ad-imginfo"}>Name: {this.state.imgName}</div>
                    <div className={"ad-imginfo"}>Dimensions: {this.state.imgWidth}x{this.state.imgHeight}</div>
                    {isValid &&
                    <div className={"ad-imginfo"} style={{color: "#155724", background: "#d4edda"}}>Image is valid.</div>
                    }
                    {!isValid &&
                    <div className={"ad-imginfo"} style={{color: "#721c24", background: "#f8d7da"}}>Image is not
                      valid.</div>
                    }
                  </React.Fragment>
                  }
                  <button style={{marginTop: "15px"}} type="button" className="ad-greenbutton" name="" onClick={(evt) => {this.handleUpload(evt)}} disabled={this.state.upDisabled}>Upload banner</button>
                </React.Fragment>
              }
              {!showUpload &&
                <button style={{marginTop: "15px"}} type="button" className="ad-greenbutton" name="" onClick={(evt) => {this.handleContinueToBilling(evt)}}>Continue to billing</button>
              }




            </React.Fragment>
          }
          {this.props.Ads.Loaded && this.state.step === "3" &&
            <React.Fragment>
              <div className="ad-greybox">
                <div className="form-label">Country:</div>
                <div className="form-select">{ccNme}</div>
              </div>
              <div className="ad-greybox">
                <div className="form-label">Start Date:</div>
                <div className="form-select">{this.state.startDate}</div>
              </div>
              <div className="ad-greybox">
                <div className="form-label">Target Url:</div>
                <div className="form-input"><a href={this.state.url} target="_blank">{this.state.url}</a></div>
              </div>
              <div className="ad-greybox">
                <div className="form-label">Package:</div>
                <div className="form-input">{this.state.packData.Name}</div>
              </div>
              <div className="ad-greybox">
                <div className="form-label">Price:</div>
                {this.state.payby == "TOK" &&
                <div className="form-input">
                  <a title="Tokens"><i className="fas fa-coins"></i>&nbsp;{this.state.packData.Tokens} tokens</a> OR <a title="Euros">{this.state.packData.Amount}&nbsp;<i className="fa fa-euro-sign"></i> euros.</a>
                </div>
                }
                {this.state.payby == "EUR" &&
                <div className="form-input">
                  <a title="Euros">{this.state.packData.Amount}&nbsp;<i className="fa fa-euro-sign"></i> euros.</a> OR <a title="Tokens"><i className="fas fa-coins"></i>&nbsp;{this.state.packData.Tokens} tokens</a>
                </div>
                }
              </div>
              {!this.props.Billing.Loaded &&
                <p style={{width: "100%", display: "flex", alignContent: "center", justifyContent: "center"}}>
                  <img src="/imgs/loader.gif" width={"100px"} height={"100px"} alt={"Loading"}/>
                </p>
              }
              {this.props.Billing.Loaded &&
                <React.Fragment>
                  <div className="ad-greybox" style={{textAlign: "center", fontSize: "1.5rem"}}>Pay with a secure online biller.</div>

                  {billers.map((v,i) => {
                    return (
                      <div className="billing-option" key={"biller-" + i}>
                        <div className="logo"><img src={v.Logo} alt={v.Name} className={v.Name}/></div>
                        <div className="payby"><img src={v.MethodImage} alt={v.Name}/></div>
                        <div className="text">
                          {v.TranslatedDisplayText.map((tv,ti)=>{
                            return <div key={"trantxt-" + ti} dangerouslySetInnerHTML={{__html:this.getTranslationReplace(tv.Key, tv.Replaces)}}></div>
                          })}
                        </div>
                        <div className="buybutton">
                          <div onClick={(e) => {this.handleBillerBuy(e,v.BillerType)}} className="ad-greenbutton">Buy Now</div>
                        </div>
                      </div>
                    );
                  })}

                  <div className="ad-greybox" style={{textAlign: "center", fontSize: "1.5rem"}}>Or you can use your credits to pay.</div>
                  <div className="ad-greybox">
                    <div className="form-label">Your Credit:</div>
                    <div className="form-input">
                      You have <a title="Tokens"><i className="fas fa-coins"></i>&nbsp;{tokens} tokens</a> and <a title="Euros">{euros}&nbsp;<i className="fa fa-euro-sign"></i> euros.</a>
                    </div>
                  </div>

                  <div className="billing-credits-desc">
                    <span>Pay By Credits</span>
                    <p>If you have sufficient funds in tokens or credits you can pay automatically by pressing one of the <i>Pay Now</i> buttons to the right.</p>
                  </div>
                  <div className="billing-credits-submit">
                    <button onClick={(e) => {this.handlePayByCredits(e,"TOK")}} type="button" className="ad-greenbutton">Pay Now By Tokens</button>
                    <button onClick={(e) => {this.handlePayByCredits(e,"EUR")}} style={{marginTop: "15px"}} type="button" className="ad-greenbutton">Pay Now By Euros</button>
                  </div>



                  <div className="secure-div">
                    <img src="/imgs/billing/secure-site.png" alt="" style={{margin: "50px auto"}}/>
                  </div>


                </React.Fragment>

              }
            </React.Fragment>
          }
          {(this.props.Ads.Loaded && this.state.step === "4" && this.state.loadBiller === "PAY") &&
            <React.Fragment>
                {!this.props.Ads.Order.Loaded &&
                  <React.Fragment>
                    <div className="large-text">Please wait, processing order</div>
                    <p style={{width: "100%", display: "flex", alignContent: "center", justifyContent: "center"}}>
                      <img src="/imgs/loader.gif" width={"100px"} height={"100px"} alt={"Loading"}/>
                    </p>

                  </React.Fragment>
                }
                {this.props.Ads.Order.Loaded &&
                  <React.Fragment>
                    {this.props.Ads.Order.Result.Approved &&
                      <React.Fragment>
                        <div className="large-text green" style={{marginBottom: "25px"}}><i className="fa fa-thumbs-up"></i>&nbsp;&nbsp;&nbsp;Order Approved</div>
                        <div className="medium-text">Your order has been approved, please allow 12-24 hours for your banner to be approved.</div>
                        <div className="medium-text">If you have any questions about your order please contact us on our <Link to={wActs.getCultPath(this.props.WebPage,"/support")}>Support Page.</Link></div>
                      </React.Fragment>
                    }
                    {!this.props.Ads.Order.Result.Approved &&
                    <React.Fragment>
                      <div className="large-text red" style={{marginBottom: "25px"}}><i className="fa fa-thumbs-down"></i>&nbsp;&nbsp;&nbsp;Order Declined</div>
                      <div className="medium-text">Your order has been declined, for the reason of "<i>{this.props.CheckOrder.Result.Message}</i>".</div>
                      <div className="medium-text">You can choose to try a different method of paying for your order by <a href="#none" onClick={(e)=>{this.handleBackToBilling(e)}}>clicking here</a>.</div>
                      <div className="medium-text">If you have any questions about your order please contact us on our <Link to={wActs.getCultPath(this.props.WebPage,"/support")}>Support Page.</Link></div>
                    </React.Fragment>
                    }
                  </React.Fragment>
                }
              <div className="secure-div">
                <img src="/imgs/billing/secure-site.png" alt="" style={{margin: "50px auto"}}/>
              </div>
            </React.Fragment>
          }
          {(this.props.Ads.Loaded && this.state.step === "4" && this.state.loadBiller === "VXS") &&
            <React.Fragment>
              {!this.props.CreateOrder.Loaded &&
                <React.Fragment>
                  <div className="large-text">Please wait, creating order</div>
                  <p style={{width: "100%", display: "flex", alignContent: "center", justifyContent: "center"}}>
                    <img src="/imgs/loader.gif" width={"100px"} height={"100px"} alt={"Loading"}/>
                  </p>
                </React.Fragment>
              }
              {this.props.CreateOrder.Loaded &&
                <div>
                  <div className="large-text">Please wait, loading biller</div>
                  <p style={{width: "100%", display: "flex", alignContent: "center", justifyContent: "center"}}>
                    <img src="/imgs/loader.gif" width={"100px"} height={"100px"} alt={"Loading"}/>
                  </p>
                  {this.props.CreateOrder.Loaded && this.props.CreateOrder.Result.Code === 200 &&
                  <form ref = {(ref) => this.billingForm = ref} action="https://secure.vxsbill.com/ezbill.php3" method="POST">
                    <input type="hidden" name="order_id" value={fdta.OrderId} />
                    <input type="hidden" name="user_1" value={fdta.Data[0]} />
                    <input type="hidden" name="user_2" value={fdta.Data[1]} />
                    <input type="hidden" name="city" value="" />
                    <input type="hidden" name="country" value="" />
                    <input type="hidden" name="zip" value="" />
                    <input type="hidden" name="site" value={fdta.Data[2]} />
                    <input type="hidden" name="layout" value="10" />
                  </form>
                  }
                </div>
              }

              <div className="secure-div">
                <img src="/imgs/billing/secure-site.png" alt="" style={{margin: "50px auto"}}/>
              </div>
            </React.Fragment>
          }
          {(this.props.Ads.Loaded && this.state.step === "5" && this.state.loadBiller === "VXS") &&
            <React.Fragment>

              {!this.props.CheckOrder.Loaded &&
                <React.Fragment>
                  <div className="large-text">Please wait, checking order</div>
                  <p style={{width: "100%", display: "flex", alignContent: "center", justifyContent: "center"}}>
                    <img src="/imgs/loader.gif" width={"100px"} height={"100px"} alt={"Loading"}/>
                  </p>
                </React.Fragment>
              }

              {this.props.CheckOrder.Loaded &&
                <React.Fragment>
                  {this.props.CheckOrder.Result.Result.Approved &&
                  <React.Fragment>
                    <div className="large-text green" style={{marginBottom: "25px"}}><i className="fa fa-thumbs-up"></i>&nbsp;&nbsp;&nbsp;Order Approved</div>
                    <div className="medium-text">Your order has been approved, please allow 12-24 hours for your banner to be approved.</div>
                    <div className="medium-text">Your Order ID for reference is: # {this.props.CheckOrder.Result.Result.Data[0]}.</div>
                    <div className="medium-text">Your Transaction ID for reference is: # {this.props.CheckOrder.Result.Result.TransactionId}.</div>
                    <div className="medium-text">If you have any questions about your order please contact us on our <Link to={wActs.getCultPath(this.props.WebPage,"/support")}>Support Page.</Link></div>
                  </React.Fragment>
                  }
                  {!this.props.CheckOrder.Result.Result.Approved &&
                  <React.Fragment>
                    <div className="large-text red" style={{marginBottom: "25px"}}><i className="fa fa-thumbs-down"></i>&nbsp;&nbsp;&nbsp;Order Declined</div>
                    <div className="medium-text">Your order has been declined, for the reason of "<i>{this.props.CheckOrder.Result.Message}</i>".</div>
                    <div className="medium-text">Your Order ID for reference is: # {this.props.CheckOrder.Result.Result.Data[0]}.</div>
                    <div className="medium-text">You can choose to try a different method of paying for your order by <a href="#none" onClick={(e)=>{this.handleBackToBilling(e)}}>clicking here</a>.</div>
                    <div className="medium-text">If you have any questions about your order please contact us on our <Link to={wActs.getCultPath(this.props.WebPage,"/support")}>Support Page.</Link></div>
                  </React.Fragment>
                  }
                </React.Fragment>
              }




              <div className="secure-div">
                <img src="/imgs/billing/secure-site.png" alt="" style={{margin: "50px auto"}}/>
              </div>
            </React.Fragment>
          }

          <div className="padding-div" style={{height: "50px"}}>&nbsp;</div>



          <div className="ad-greybox" style={{textAlign: "left", lineHeight: "15px", fontSize: "1.3rem"}} dangerouslySetInnerHTML={{__html: this.getTranslation("page.advertise.networkofsitesheader")}}></div>



          <div className={"flex-center"} style={{background: "white"}}>
            <div className={centerBan}>
              <SwBanner apiAnonId={this.props.WebPage.Request.AnonymousId}  id={"our-network-300x100"} channel={wActs.SubDomain(this.props.WebPage)} count={"10"} minBuyAds={"0"} maxBuyAds={"0"} className={"network-banners"} ApiReferer={this.props.WebPage.ServerParams.Referer}>
                <BuyAdBanner size={"300x100"} hideBottom={true} textButton={this.getTranslation("page.advertise.advertisehere")} textTop={this.getTranslation("page.advertise.getxtimesmorevisitors")} textBottom={this.getTranslation("page.advertise.buyabanneraddtoday")}/>
              </SwBanner>
            </div>
          </div>

          <div className="padding-div">&nbsp;</div>


        </div>
      </div>
    );
  }





}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
    Ads: state.Ads,
    Billing: state.Billing,
    CreateOrder: state.Billing.CreateOrder,
    CheckOrder: state.Billing.CheckOrder
  };
};

export default connect(mapStateToProps)(Advertise);
